import React from "react";

import DeviceIcon from "../DeviceCommons/DeviceIcon/DeviceIcon";
import DeviceItemAlarm from "./DeviceGridItemParts/DeviceItemAlarm";
import DeviceItemUptime from "./DeviceGridItemParts/DeviceItemUptime";
import DeviceStatusIndicator from "../DeviceCommons/DeviceStatusIndicator/DeviceStatusIndicator";

import "./DeviceGridItem.scss";

export default class DeviceGridItem extends React.PureComponent {    
    render() {
        const device = this.props.device;
        const classes = this.props.selected ? "device-grid-item-container selected" : "device-grid-item-container";

        // Count number of alerts that are active based on severity
        // const alertCounts = device.alerts.reduce(
        //     (col, al) => {
        //         if (al.state === "ACTIVE") {
        //             col.total++;
        //             if (al.severity >= 0.8) {
        //                 col.crit++;
        //                 return col;
        //             }
        //             if (al.severity >= 0.5) {
        //                 col.high++;
        //                 return col;
        //             }
        //             if (al.severity >= 0.3) {
        //                 col.med++;
        //                 return col;
        //             }
        //         }
        //         return col;
        //     },
        //     { crit: 0, high: 0, med: 0, total: 0 }
        // );

        const alertCounts = {
            total: device.alertCount.active.total,
            critical: device.alertCount.active.criticalSeverity,
            urgent: device.alertCount.active.urgentSeverity,
            oos: device.alertCount.active.oosSeverity
        }

        // console.log(device.alertCount)
        // console.log(typeof device.alertCount.active.total)

        const hideStatus = (device !== undefined && device.upTime === null && device.isOnline === false);

        return (
            <div
                className={classes}
                onClick={() => {
                    this.props.onClick(this.props.device);
                }}
            >
                <div className="icon">
                    <DeviceIcon device={device} />
                </div>

                <div className="description">
                    <span>
                        <h4>
                            <strong>{device.name}</strong>
                        </h4>
                        <h4>{device.code}</h4>
                    </span>
                </div>

                {!hideStatus && <div className="online">
                    <DeviceItemUptime device={device} />
                </div>}
                {!hideStatus && <div className="state">
                    <DeviceStatusIndicator device={device} />
                </div>}

                {hideStatus && <div className="offline">
                    <p>Offline</p>
                </div>}


                <div className="alarms-title">
                    <h4>Alarms: {alertCounts.total} <span> / {device.alertCount.all}</span></h4>
                </div>

                <div className="alarm-oos">
                    <DeviceItemAlarm type="oos" device={device} alarmCount={alertCounts.oos} />
                </div>
                <div className="alarm-urgent">
                    <DeviceItemAlarm type="urgent" device={device} alarmCount={alertCounts.urgent} />
                </div>
                <div className="alarm-critical">
                    <DeviceItemAlarm type="critical" device={device} alarmCount={alertCounts.critical} />
                </div>
            </div>
        );
    }
}
